import React, { Fragment } from 'react';

import { useSelector } from 'react-redux';
import { IFrame } from '@klp/iframe';

import { Main } from '@klp/layout';
import { useTranslation } from 'react-i18next';

import { EnvironmentAccess, PowerBiEnvironmentalProfileURL } from '../config';

import { kommentarerAccess } from '@klp/kommentarer/config';
import { KommentarerView } from '@klp/kommentarer';
import { makeStyles } from '@material-ui/core/styles';
import { contextSelectors } from '@klp/contextSelector';
import { useCurrentUser } from '@klp/auth';

const useStyles = makeStyles(() => ({
    iframe: {
        paddingTop: '20px',
    },
}));

export default function EnvironmentView() {
    const { t } = useTranslation();
    const classes = useStyles();
    const { currentUser } = useCurrentUser();
    const { selectedContext } = useSelector(contextSelectors);

    const filteredEnvironmentalProfileLinkHandler = () => {
        let filteredLink = PowerBiEnvironmentalProfileURL();

        if (selectedContext?.nummer !== undefined) {
            filteredLink += `&filter=Dim_ByggAvdeling/bygg_avdeling_id%20eq%20%27${selectedContext.nummer}%27`;

            return filteredLink;
        }

        return filteredLink;
    };

    return (
        <>
            <Main>
                <Main.Breadcrumbs>
                    <Main.Crumb
                        id="environment"
                        label={t('breadcrumbs.environmentProfile')}
                    />
                </Main.Breadcrumbs>
                {EnvironmentAccess(currentUser) &&
                    (!selectedContext ? (
                        /* Add a better error message / component here */
                        <div
                            style={{
                                display: 'flex',
                                width: '100%',
                                height: '100%',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <p>{t('environment.noContextSelected')}</p>
                        </div>
                    ) : (
                        <IFrame
                            src={filteredEnvironmentalProfileLinkHandler()}
                            fullScreen={true}
                            noSandbox={true}
                            className={classes.iframe}
                        />
                    ))}
            </Main>
            {kommentarerAccess() && <KommentarerView disableDragger={true} />}
        </>
    );
}
